import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import SearchBox from 'components/common/SearchBox';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import JobPostList from './list/JobPostList';
import { useFindJobPostQuery } from 'service/recruiterQuery/recruiterQuery';
import { Post } from 'components/modules/card/jobPost/jobPost.type';
import { Form } from 'react-bootstrap';
import Empty from 'components/base/Empty';

function JobPost() {
  const [jobPost, setJobPost] = useState<Post[]>([]);
  const { data, refetch, isLoading } = useFindJobPostQuery('');
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const status = searchParams.get('status') || 'Active';

  const updateJobPost = () => {
    const responseData = data as Post[];
    const filteredData = [];
    for (const item of responseData) {
      if (item.status === status) {
        filteredData.push(item);
      }
    }
    setJobPost(filteredData);
  };

  const handleStatusChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    if (value === 'Active') {
      searchParams.delete('status');
    } else {
      searchParams.set('status', value);
    }
    navigate(`?${searchParams.toString()}`);
  };

  useEffect(() => {
    if (Array.isArray(data)) {
      updateJobPost();
    }
  }, [data, status]);
  return (
    <div>
      <div className="d-flex flex-wrap justify-content-between gap-3">
        <div className="ms-xxl-auto d-flex gap-3">
          <SearchBox placeholder="Search by title" />
          <Form.Select
            className="w-auto"
            value={status}
            onChange={handleStatusChange}
          >
            <option value="Active">Active</option>
            <option value="Expired">Expired</option>
            <option value="Closed">Closed</option>
          </Form.Select>
        </div>
        <Button
          variant="primary"
          as={Link}
          to="/panel/recruitment/careers/jobs/add"
        >
          <FontAwesomeIcon icon={faPlus} className="me-2" />
          Add Job Post
        </Button>
      </div>
      <div className="mt-4 mb-6">
        <Row>
          <Col xs={12}>
            {isLoading ? (
              <div className="d-flex justify-content-center w-100">
                <Spinner animation="border" role="status" className="me-2">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : Array.isArray(jobPost) && jobPost.length === 0 ? (
              <div className="d-flex justify-content-center align-items-center flex-column gap-4 w-100 mt-3">
                <Empty />
                <h3 className="text-body-tertiary">
                  No matching records found.
                </h3>
              </div>
            ) : (
              <JobPostList data={jobPost} type="post" refetch={refetch} />
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default JobPost;
